import React, { forwardRef } from 'react';
import { useTheme } from '@mui/material/styles';
import { Avatar, AvatarProps } from '@mui/material';

// ----------------------------------------------------------------------

type AvatarColor = 'default' | 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error';

// ----------------------------------------------------------------------

export type MAvatarProps = {
  color?: AvatarColor;
} & AvatarProps;

const MAvatar = forwardRef<HTMLDivElement, MAvatarProps>(
  ({ color = 'default', children, sx, ...other }: any, ref: any) => {
    const theme: any = useTheme();

    if (color === 'default') {
      return (
        <Avatar ref={ref} sx={sx} {...other}>
          {children}
        </Avatar>
      );
    }

    return (
      <Avatar
        ref={ref}
        sx={{
          fontWeight: theme?.typography?.fontWeightMedium,
          color: theme?.palette[color]?.contrastText,
          backgroundColor: theme?.palette[color]?.main,
          ...sx
        }}
        {...other}
      >
        {children}
      </Avatar>
    );
  }
);

export default MAvatar;
